export default "__VITE_ASSET__7624d5ae__"